import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contact: "/contact",
  rheology: "/rheology",
  check_rheology_access: "/Rheology/check-access",
};

const endpointsSlice = createSlice({
  name: "endpoints",
  initialState,
});

export const {} = endpointsSlice.actions;
export default endpointsSlice.reducer;
